import { LogoIconNombreSVG } from "@/Components/Index";
import { Link } from "react-router-dom";

type Props = {
  titulo: string;
  toLink: string;
  classIcon: string;
};

export const HeaderCategoryWeb = ({
  titulo,
  toLink,
  classIcon,
}: Props): JSX.Element => {
  return (
    <div className="ps-container">
      <div className="header__lefts">
        <Link className="ps-logo" to={toLink}>
          <LogoIconNombreSVG />
        </Link>
      </div>
      <div className="header__center d-flex justify-content-center mx-auto my-auto align-items-center">
        <h4 className="text-white mt-3">{titulo}</h4>
      </div>
      <div className="header__rights">
        <div className="d-flex justify-content-end align-items-center mx-auto">
          <Link className="header__back mt-2" to={"/"}>
            <i className={classIcon} style={{ fontSize: 30 }}></i>
          </Link>
        </div>
      </div>
    </div>
  );
};
